import { DownloadOutlined } from '@ant-design/icons';

import { Button, Dialog, Skeleton } from '../../../../components/ui';
import { useLoi } from '../../../../hooks/useLoi';
import { useT } from '../../../../i18n';
import { luuTep } from '../../../../lib/luu-tep';
import { useTepBangChung } from '../../hooks/useLichSu';
import type { TepBangChung } from '../../types';

const NHAN_XEM = { video: 'rpaBaoCao.xemVideo', log: 'rpaBaoCao.xemLog', screenshot: 'rpaBaoCao.xemAnh' } as const;

/**
 * Xem ảnh, video hoặc log bằng chứng. Tệp tải kèm token (thẻ `<img>`/`<video>` không gắn được header) rồi mở bằng URL
 * tạm. Máy chủ trả tệp với `nosniff` và CSP `sandbox`: đây là dữ liệu Robot gửi lên, không tin cậy.
 */
export function HopXemTep({ executionId, tep, onClose }: { executionId: string; tep: TepBangChung; onClose: () => void }) {
  const { t } = useT();
  const dichLoi = useLoi();
  const laLog = tep.kind === 'log';
  const q = useTepBangChung(executionId, tep.id, laLog);
  const ten = tep.fileName || tep.id;
  const nhan = t(NHAN_XEM[tep.kind as keyof typeof NHAN_XEM] ?? NHAN_XEM.screenshot);

  return (
    <Dialog
      open
      onClose={onClose}
      width={laLog ? 860 : 960}
      title={t('rpaBaoCao.hopTepTieuDe', { loai: nhan, ten })}
      footer={
        <div className="flex flex-wrap justify-end gap-2">
          {q.data && (
            <Button variant="outline" size="md" icon={<DownloadOutlined />} onClick={() => luuTep(q.data.blob, ten)}>
              {t('rpaBaoCao.taiVe')}
            </Button>
          )}
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.dong')}
          </Button>
        </div>
      }
    >
      {q.isError ? (
        <p role="alert" className="text-sm text-danger-700">
          {dichLoi(q.error)}
        </p>
      ) : !q.diaChi ? (
        <Skeleton className="h-64 w-full" />
      ) : tep.kind === 'video' ? (
        <video src={q.diaChi} controls autoPlay muted className="max-h-[70vh] w-full rounded-lg bg-subtle">
          <track kind="captions" />
        </video>
      ) : laLog ? (
        <pre
          tabIndex={0}
          aria-label={nhan}
          className="max-h-[60vh] overflow-auto whitespace-pre-wrap break-words rounded-lg bg-subtle px-3 py-2 font-mono text-xs text-content-primary"
        >
          {q.data?.chu}
        </pre>
      ) : (
        <img src={q.diaChi} alt={ten} className="max-h-[70vh] w-full rounded-lg object-contain" />
      )}
    </Dialog>
  );
}
